<template>
    <!-- everything should be wrapped by one item for some reason -->
    <div v-if="isRootNode">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.title_peer_to_peer_setting'"></div>
        </div>
        <div class="object-inner-table">
            <table width=100%>
                <tr width="100%" class="no-data-message">
                    <td style="display: inline-block" v-html="$t('message.hint_menu_user_publish')">
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div v-else>
        <div class="object-titlebox">
            <div class="title-box-left">
                <span v-t="'message.item_save_peer_voice_setting'"/>
                <el-tooltip effect="dark" placement="top-start">
                    <div slot="content" style="text-align:left" v-html="$t('message.hint_save_voice')"></div>
                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                </el-tooltip>
            </div>
        </div>

        <div class="object-titlebox">
                <div class="object-titlebox-right">
                    <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck()">
                        <img src="../../../../assets/edit.svg"/>
                        <span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                    </button>
                </div>
            </div>
            <table width=100%>
                <tr class="objectitem-record">
                    <td width=40% class="object-item" v-t="'message.item_save_peer_voice_setting'"></td>
                    <td class="object-value">{{ stateText }}</td>
                </tr>
            </table>
        <disableP2PSaveTenantEdit v-if="showDisableP2PSaveTenantEdit" ref="DisableP2PSaveTenantEdit" :appData="appData" @save="setDisableP2PSave" @cancel="showDisableP2PSaveTenantEdit=false"></disableP2PSaveTenantEdit>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import DisableP2PSaveTenantEdit from '@/components/pc/setting/p2pSaveVoice/DisableP2PSaveVoiceTenantEdit.vue';

export default {
    components: {
        disableP2PSaveTenantEdit: DisableP2PSaveTenantEdit,
    },
    props: {
        selectedNode: {},
        appData: {},
    },
    data() {
        return {
            showDisableP2PSaveTenantEdit: false,
        };
    },
    computed: {
        stateText () {
            return this.appData.disableP2PSaveVoice ? commonUtil.getMessageText(this.$i18n, "item_no_save") : commonUtil.getMessageText(this.$i18n, "item_save")
        },
        isRootNode () {
            return this.selectedNode.data.type === constants.SETTING_P2P_ROOT;
        },
    },
    methods: {
        showDialogAfterWritableCheck() {
            if (!this.$root.store.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                return;
            }
            this.showDisableP2PSaveTenantEdit = true;
        },
        async setDisableP2PSave(disableP2PSaveVoice) {
            this.showDisableP2PSaveTenantEdit = false
            let res;
            try {
                res = await server.post('/setdisablep2psavevoice', {disableP2PSaveVoice : disableP2PSaveVoice})
            } catch(error) {
                commonUtil.putExceptionErrorMessage(this, "setDisableP2PSaveVoice", error);
                return;
            }

            switch (res.data.status) {
                case constants.STATUS_SUCCESS:
                    commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n,"info_disable_p2p_save_edited"));
                    this.appData.disableP2PSaveVoice = disableP2PSaveVoice;
                    break;
                default:
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","setDisableP2PSaveVoice").replace("{code}",res.data.status));
                    break;
            }
        }
    },
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.header-value {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #848991;
    font-size: 12px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.detailed-header {
    width: 95%;
    background-color: #f6f6f6;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 12px;
}
.detailed-table {
    width: 95%;
    margin-left: 20px;
}
.detailed-tr {
    border-bottom:1px #eee solid;
}
.detailed-left {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 40%;
}
.select-setting {
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
    width:35%;
    height:100%;
    valign:top
}
.vertical-line-addition {
    height: 100vh;
    margin: 0;
    padding: 0;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}
.code-guide-text {
     font-size: 16px;
     font-weight: 600;
     color: #5171cb;
 }


</style>
